import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AuthenticationManagement from '../components/AuthenticationManagement';

function ProtectedLayout() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        width: '100dvw',
        overflow: 'hidden',
      }}
    >
      {/* Centralized logout interceptor */}
      <AuthenticationManagement />

      {/* Main content */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default ProtectedLayout;
